import classNames from 'classnames';
import { forwardRef } from 'react';

const TableRow = forwardRef((props, ref) => {
  const {
    extraClassNames,
    edit,
    unavailable,
    hasError,
    styles,
    children,
    ...rest
  } = props;
  return (
    <tr
      ref={ref}
      className={classNames('c-table__row', extraClassNames, {
        'c-table__row--edit': edit,
        'c-table__row--unavailable': unavailable
      })}
      style={{ color: hasError ? 'red' : '', ...styles }}
      {...rest}
    >
      {children}
    </tr>
  );
});

export default TableRow;
